import { 
    PRODUCT_DETAILS_FAIL,
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_LIST_FAIL, 
    PRODUCT_LIST_REQUEST, 
    PRODUCT_LIST_SUCCESS 
    } from "../Constants/productConstants"

import { collection, doc, getDoc, getDocs, orderBy, query } from 'firebase/firestore';
import { firestore } from "../firebase" 

export const listProducts = () => async (dispatch) =>{
    dispatch({
        type: PRODUCT_LIST_REQUEST,
    });

    const q = query(collection(firestore, 'PRODUCTS'), orderBy('added_on'));
    getDocs(q)
        .then((querySnapshot) =>{
            let data = []
            if(!querySnapshot.empty){
                querySnapshot.forEach((doc) => {
                   
                   const p = doc.data();
                   const approve = p?.approve;
                   const approveStr = (approve ?? '').toString().toLowerCase().trim();
                   const isApproved = approve === true || approveStr === 'approved' || approveStr === 'true';
                   if (isApproved) data.push(p);
                });
            }
            dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data })
        })
        .catch((error) => {
            dispatch({ type: PRODUCT_LIST_FAIL, payload: error.message})
        })

   
}

export const detailsProduct = (productId) => async(dispatch) =>{
    dispatch({
        type: PRODUCT_DETAILS_REQUEST, payload: productId
    });
        try {
            const docRef = doc(firestore, 'PRODUCTS', productId);
            const docSnap = await getDoc(docRef);
            let data;
            if(docSnap.exists()){
                data= docSnap.data();
                const approve = data?.approve;
                const approveStr = (approve ?? '').toString().toLowerCase().trim();
                const isApproved = approve === true || approveStr === 'approved' || approveStr === 'true';
                if (!isApproved) {
                    dispatch({ type: PRODUCT_DETAILS_FAIL, payload: "Product Not Found!" });
                    return;
                }
                dispatch({ type: PRODUCT_DETAILS_SUCCESS, payload: data })
            }else{
                dispatch({ type: PRODUCT_DETAILS_FAIL, 
                    payload: "Product Not Found!"
                    });
            }
            
        } catch (error) {
            dispatch({ type: PRODUCT_DETAILS_FAIL, 
                payload: 
                    error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
            });
        }

          
    

}